export const fluFinderWidgetUrl = 'https://intermountainhealthcare.org/flu';
export const imagingServicesUrl =
  'https://intermountainhealthcare.org/services/imaging-services/locations/';

export const covidTestingFacilities = 'https://ckr.ihc.com/ckr-ext/Dcmnt?ncid=529965963';
export const myHealthPlus = 'https://intermountainhealthcare.org/patient-tools/my-health-plus/';
